module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "software"
  }, [(_vm.software.iconUrl) ? _c('img', {
    staticClass: "software-icon",
    attrs: {
      "src": _vm.software.iconUrl
    }
  }) : _c('img', {
    staticClass: "software-icon",
    attrs: {
      "src": "https://dummyimage.com/48x48/595b75/fff"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "software-name"
  }, [_vm._v(_vm._s(_vm.software.name))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d4a5ce02!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/GallerySoftware.vue
// module id = 2133
// module chunks = 2